module.exports = __webpack_public_path__ + "static/media/img-newtaipeicity-zh-desktop.732fec32.svg";